import { LogTransport, EnrichedLogEntry } from '../types';
import { LogLevel } from '../levels';
import { datadogLogs } from '../../../services/datadog';

export class DatadogTransport implements LogTransport {
  readonly name = 'datadog';

  send(entry: EnrichedLogEntry): void {
    try {
      const { message, level, error, ...context } = entry;

      switch (level) {
        case LogLevel.ERROR:
          datadogLogs.logger.error(message, context, error);
          break;
        case LogLevel.WARN:
          datadogLogs.logger.warn(message, context);
          break;
        case LogLevel.INFO:
          datadogLogs.logger.info(message, context);
          break;
        default:
          datadogLogs.logger.debug(message, context);
      }
    } catch {
      // never throw from transport
    }
  }
}
